import { VisiblePrescriptionStatus } from "common/types/prescriptions";

import { StatusColor } from "client/common/components/content/Status";

const exhaustiveStatusCheck = (status: never): StatusColor => {
  console.warn(`Missing color for prescription status ${status}`);
  return "greyscale";
};

export const getColorForPrescriptionStatus = (status: VisiblePrescriptionStatus): StatusColor => {
  switch (status) {
    case VisiblePrescriptionStatus.Active:
      return "success";
    case VisiblePrescriptionStatus.ImportedActive:
    case VisiblePrescriptionStatus.ImportedInactive:
    case VisiblePrescriptionStatus.Draft:
      return "greyscale";
    case VisiblePrescriptionStatus.ExpiringSoon:
      return "warning";
    case VisiblePrescriptionStatus.Declined:
    case VisiblePrescriptionStatus.Expired:
    case VisiblePrescriptionStatus.NoFillsRemaining:
      return "danger";
    default:
      return exhaustiveStatusCheck(status);
  }
};

const exhaustiveLabelCheck = (status: never): string => {
  console.warn(`Missing label for prescription status ${status}`);
  return "Unknown";
};

export const getLabelForPrescriptionStatus = (status: VisiblePrescriptionStatus) => {
  switch (status) {
    case VisiblePrescriptionStatus.Active:
      return "Active Prescription";
    case VisiblePrescriptionStatus.Declined:
      return "Declined Prescription";
    case VisiblePrescriptionStatus.Draft:
      return "Draft Prescription";
    case VisiblePrescriptionStatus.ImportedActive:
    case VisiblePrescriptionStatus.ImportedInactive:
      return "Imported Prescription";
    case VisiblePrescriptionStatus.ExpiringSoon:
      return "Expiring Soon";
    case VisiblePrescriptionStatus.Expired:
      return "Expired Prescription";
    case VisiblePrescriptionStatus.NoFillsRemaining:
      return "No Fills Remaining";
    default:
      return exhaustiveLabelCheck(status);
  }
};
